import { render, staticRenderFns } from "./CouponVava.vue?vue&type=template&id=313697ae&scoped=true"
import script from "./CouponVava.vue?vue&type=script&lang=js"
export * from "./CouponVava.vue?vue&type=script&lang=js"
import style0 from "./CouponVava.vue?vue&type=style&index=0&id=313697ae&prod&lang=less&scoped=true"
import style1 from "./CouponVava.vue?vue&type=style&index=1&id=313697ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313697ae",
  null
  
)

export default component.exports